import React, {useState} from 'react';
import axios from "axios";
import Helper from "../support/Helper";
import {toast} from "react-toastify";
import Auth from "@system/config/auth";
import logo from 'src/assets/images/logo.svg';

const ResetPassword = () => {
    let [data, setData] = useState({});
    let [email, setEmail] = useState({});
    let [emailValid, setEmailValid] = useState(false);
    let [message, setMessage] = useState('');
    let [sAuth, setSAuth] = useState({success: null});
    const serverCall = async () => {
        if (data) {
            await axios.put(Auth.CHANGE_PASSWORD, data).then((res) => {
                setSAuth({success: res.data.isSuccessFull});
                if (res.data.isSuccessFull) {
                    setMessage(res.data.errorMessage);
                    toast.success(res.data.errorMessage, {
                        position: "bottom-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                } else {
                    toast.error(res.data.errorMessage, {
                        position: "bottom-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            })
        } else {
            setSAuth({success: false});
        }
    };
    const validateEmail = async () => {
        await axios.get(Helper.getBaseUrl() + `/api/user/userValidate/` + email).then((res) => {
            setEmailValid(res.data.isSuccessFull);
            if (res.data.isSuccessFull) {
                toast.success(res.data.errorMessage, {
                    position: "bottom-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } else {
                toast.error(res.data.errorMessage, {
                    position: "bottom-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        })
    };
    const setInput = (e, name) => {
        let a = data;
        a[name] = e.target.value;
        setData(a);
    };
    return (
        <>
            <div className="login-page">
                <div className="login-wrapper">
                    <div className="login-logo">
                        <img className="img-fluid" src={logo}/>
                    </div>
                    <div className="login-box pb-0"
                         style={
                             sAuth.success === true ? {
                                 height: 'auto'
                             } : {}
                         }
                    >
                        {sAuth.success === true &&
                        <div>
                            <div className="signin-title text-green pb-5"
                                 style={
                                     {
                                         fontSize: '21px'
                                     }
                                 }
                            >{message || 'Your password has been changed successfully.'}</div>
                        </div>
                        }

                        {(!sAuth.success || sAuth.success === false) &&
                        <>
                            <div className="signin-title text-green">Reset Password</div>
                            <div>
                                {emailValid === false &&
                                <>
                                    <div className="form-group">
                                        <label htmlFor="email">Email:<span className="astric">*</span></label>
                                        <div className="input-box input-box-email">
                                            <input type="email" className="form-control" id="email"
                                                   placeholder="Enter Email"
                                                   onChange={e => setEmail(e.target.value)}
                                                   name="email"/>
                                        </div>
                                    </div>
                                    <div className="text-center">
                                        <button
                                            disabled={!email}
                                            type="submit" className="bs5 btn btn-primary w-100 login-btn mb-4 "
                                            onClick={e => validateEmail()}
                                        >Validate Email
                                        </button>
                                    </div>
                                </>
                                }

                                {emailValid === true &&
                                <>
                                    <div className="form-group">
                                        <label htmlFor="email">New Password:<span className="astric">*</span></label>
                                        <div className="input-box input-box-email"/>
                                        <input type="password" className="form-control" id="email"
                                               placeholder="Enter password"
                                               onChange={e => setInput(e, 'oldPassword')}
                                               name="email"/>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="pwd">Confirm Password:<span className="astric">*</span></label>
                                        <div className="input-box input-box-email"/>
                                        <input type="password" className="form-control" id="email"
                                               placeholder="Confirm password"
                                               onChange={e => setInput(e, 'newPassword')}
                                               name="email"/>
                                    </div>
                                    <div className="text-center">
                                        <button
                                            type="submit" className="bs5 btn btn-primary w-100 login-btn mb-4"
                                            onClick={e => serverCall()}
                                        >SIGN IN
                                        </button>
                                    </div>
                                </>
                                }
                            </div>
                        </>
                        }
                    </div>
                    <div className="login-help">
                        <a href="">Continue to www.avnet.com </a>
                        <a href="">Help </a>
                    </div>
                </div>
                <div className="login-footer">
                    Copyright ©2022 Avnet, Inc. All rights reserved.
                </div>
            </div>
        </>
    )
}

export default ResetPassword;